<template>
  <div class="org-tree-container">
    <el-tree
      ref="orgTree"
      :data="orgTreeShowInfo.orgs"
      :props="defaultProps"
      node-key="id"
      default-expand-all
      highlight-current
      @node-click="handleNodeClick"
      style="width: 100%">
    </el-tree>
  </div>
</template>

<script>
import { listOrgTree } from '@/api/frame/orgApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'OrgTreeShow',
  props: {
    callBackListener: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      orgTreeShowInfo: {
        orgs: [],
        curOrg: {}
      },
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this._loadOrgsShow()
  },
  methods: {
    async _loadOrgsShow() {
      try {
        const res = await listOrgTree({
          communityId: this.shopId
        })
        this.orgTreeShowInfo.orgs = [res.data]
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleNodeClick(data) {
      this.orgTreeShowInfo.curOrg = data
      this.orgTreeShowInfo.curOrg.orgId = data.id
      this.$emit('switchOrg', {
        orgId: data.id,
        orgName: data.text
      })
    },
    refreshTree() {
      this._loadOrgsShow()
    }
  }
}
</script>

<style scoped>
.org-tree-container {
  padding: 10px;
}
</style>